"use client";

import { ChangeEvent } from "react";
import { VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { inputVariants } from "./text-input";
import { Search } from "../icons/search";

interface SearchInputProps extends VariantProps<typeof inputVariants> {
  name: string;
  value?: string;
  placeholder?: string;
  type?: string;
  className?: string;
  onChange?: (value: string) => void;
}

export const SearchInput = ({
  name,
  value,
  placeholder,
  variant,
  height,
  radius,
  onChange,
  className = "",
  type = "search",
  ...props
}: SearchInputProps) => {
  const handleValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <div className={cn("w-full relative flex items-center", className)}>
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={handleValueChange}
        className={cn(inputVariants({ height, variant, radius }), "pl-10")}
        {...props}
      />
      <Search
        className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400"
        aria-hidden="true"
      />
    </div>
  );
};
